export default __webpack_public_path__ + "static/media/clock-2.48324a43.svg";